import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";

let idHotsiteLocalStorage = getlocalStorageIdHotsite();

export const variables: IVariable = {
  IdHotsite: idHotsiteLocalStorage > 0 ? idHotsiteLocalStorage : 11,
  Loja: "CVC",
  UserStorage: "bK4/vas==",
  UserToken: "vasasx==",
  UrlApi: "https://hlg-ecommerce-glp-api.primecase.com.br/api",
  UrlLoja:"https://hlg-ecommerce-glp-web.primecase.com.br/",
  UrlServiceHost: "https://dev-pri-svc-api.primecase.com.br/",
  OrgId: "",
  ProviderMerchantId: "",
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#24324f",
      light: "#977a21",
      //lighter: "#ece6f7",
      dark: darkenColor("#977a21", 10), // Escurece em 20%
    },
    secondary: {
      main: "#000",
    },
    error: {
      main: "#a91c1c",
    },
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
